import * as Yup from 'yup';
import { reverseShape } from 'Components/shared/helpers/reverse-shape';
import {
    email,
    fullContact,
    fullName,
    gender,
    password,
    identificationType,
    identificationNumber,
    passportIssueDate,
    passportExpiryDate,
    passportPlaceOfIssue,
} from 'Components/shared/helpers/validations';

const moType = Yup.mixed().oneOf(['DOCTOR', 'NURSE', 'MEDICAL-ASSISTANT']);

export const AccountCreateSchema = Yup.object().shape(reverseShape({
    moType: moType.required(),
    fullName: fullName.required(),
    gender: gender.required(),
    identificationType: identificationType.required(),
    identificationNumber: identificationNumber.required(),
    identificationIssueDate: passportIssueDate,
    identificationExpiryDate: passportExpiryDate,
    identificationPlaceOfIssue: passportPlaceOfIssue,
    contactNo: fullContact.optional(),
    email: email.required(),
    // password: password.required(),
    // confirmPwd: password.required(),
}))
